export type CargoInsuranceCancellationReasonId = string | number;

export type CargoInsuranceCancellationReason = {
  id: CargoInsuranceCancellationReasonId;
  description?: string;
};

export class CargoInsuranceCancellationRequest {
  cancellationReason: string;
  cancellationDetails?: string;

  constructor(opts: Partial<CargoInsuranceCancellationRequest>) {
    if (!opts.cancellationReason) {
      throw new Error('cancellationReason is required');
    }
    this.cancellationReason = opts.cancellationReason;
    this.cancellationDetails = opts.cancellationDetails;
  }
}
